import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { hasAccess } from "@/lib/roles";
import { useVisibility, canSee, invalidateVisibility } from "@/lib/visibility";

export default function ProtectedRoute({ children, roles, feature }) {
  const { user, loading } = useAuth();
  const vis = useVisibility(user?.id);
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[color:var(--text-secondary)]">
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !hasAccess(user.role, roles)) return <Navigate to="/dashboard" replace />;
  if (feature && vis && !canSee(vis.my_access, feature)) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6">
        <div className="hos-card p-8 max-w-md text-center">
          <div className="font-heading text-3xl text-[color:var(--gold)] mb-2">Access Restricted</div>
          <div className="text-sm text-[color:var(--text-secondary)] mb-4">
            This feature is not currently available for your role.
          </div>
          <a href="/dashboard" className="hos-btn-primary inline-block">Return to Home</a>
        </div>
      </div>
    );
  }
  return children;
}
